import { styled } from '@mui/material';

export const PreviewMarkdownLinkElement = styled('a', {
  name: 'DsPreviewMarkdown',
  slot: 'Link',
  overridesResolver: (_, theme) => {
    return [theme.link];
  },
})<{ href?: string; target: string; rel: string }>({});
